import router from '@/router'
import http from '@/utils/http';
import notify from '@/utils/notify'
import format from '@/utils/format'
import Api from '@/conf/Api';
import { onboarding } from '../../conf/conf';
const DEFAULT = (fn, commit) => fn().then(e => (notify(commit, e), e)).catch(e => (notify(commit, e), e))

export const MATERIAL_JOB = ({ commit }, d) => {
    let url = ''
    if (d.t == 'put' || d.t == 'del') url += d.id
    if (d.t == 'get') url += d.id + '/lista'
    return DEFAULT(() => http[d.t](Api.supporter.material + url, d.p), commit)
}

export function SET_LOGIN({ commit, dispatch }, data) {

  const token = localStorage.getItem('token')

  if (!token && !data.client) {
    data.login = data.login.substr(-1) === '@' ? data.login + 'netsupport.com.br' : data.login
    data.login = data.login.toLocaleLowerCase()
    return http.post(Api.login.auth, data)
      .then((res) => {
        if (res.data.id) {
          dispatch('GET_SESSION', data);
          commit('SET_LOGIN', { status: true });
          return res
        }
      })
      .catch((err) => {

        if (err.response && err.response.status == 401)
          commit('general/SET_STATUS', { text: ((err.response.data && err.response.data.msg) || 'Usuário ou senha incorreto.'), color: 'red' }, { root: true })
        else
          commit('general/SET_STATUS', { text: ((err.response.data && err.response.data.msg) || 'Sistema indisponível no momento'), color: 'red' }, { root: true });

        return err
      });
  } else {
    dispatch('GET_SESSION', data);
  }
}

export const CONTRATO_MINUTA = ({ commit }, ID) => DEFAULT(() => http.get(Api.admin.contratos.minuta + ID), commit)
export const CONTRATO_GET = ({ commit }, ID) => DEFAULT(() => http.get(Api.admin.contratos.url + '/' + ID), commit)
export const CONTRATO_ASSINADO = ({ commit }, data) => DEFAULT(() => {
  let url = Api.supporter.clicksign.assinado + data.op
  if (data.id) url += "/doutor/" + data.id
  return http.get(url)
}, commit)

export function CLICKSIGN_CONTRATO({ commit }, { op: op, id: id }) {
  let url = Api.supporter.clicksign.contrato + op
  if (id) url += "/doutor/" + id
  return http.get(url).catch((e) => notify(commit, e))
}
export function CLICKSIGN_NOVO_CONTRATO_EXCECAO({ commit }, { id, operacao }) {
  return http.put(Api.supporter.clicksign.excecao.replace("?", id) + operacao, {})
    .catch((e) => notify(commit, e))
}
export function CLICKSIGN_NOVO_CONTRATO({ commit }, { id, operacao }) {
  return http.put(Api.supporter.clicksign.expirado.replace("?", id) + operacao, {})
    .catch((e) => notify(commit, e))
}
export function CLICKSIGN_MINUTA({ commit }, ID) {
  return http.get(Api.supporter.clicksign.minuta + ID)
    .catch((e) => notify(commit, e))
}

export function CLICKSIGN_DOWNLOAD({ commit }, ID) {
  return http.get(Api.supporter.clicksign.download + ID)
    .catch((e) => notify(commit, e))
}

export function FORGOT_PASS({ commit }, email) {
  return http.post(Api.login.forgot + email).then(() => {
    commit('general/SET_STATUS', { text: 'Se seu e-mail estiver cadastrado em nosso portal, em breve você receberá as instruções para redefinir sua senha', color: 'white' }, { root: true })
  }).catch((e) => {
    notify(commit, e)
  })
}

export function RESET_PASS({ commit }, data) {
  if (data.nova_senha === data.confirma_nova_senha)
    return http.post(Api.resetPass, data).then((r) => {
      notify(commit, r)
      return r
    }).catch((e) => {
      notify(commit, e)
      return e
    })
  else
    commit('general/SET_STATUS', { text: 'As senhas não são iguais', color: 'red' }, { root: true })
}

export function CREATE_SUPPORTER({ commit }, data) {
  data.celular = format.clear(data.celular)
  return http.post(Api.supporter.new, data).then((r) => {
    notify(commit, r)
    return r
  }).catch((e) => {
    notify(commit, e)
  })
}

export function CANDIDATES_SUPPORTER({ commit }, data) {
  return http.post(Api.supporter.candidates.list, data).catch((e) => {
    notify(commit, e)
  })
}
export function DEL_CANDIDATE_SUPPORTER({ commit }, ID) {
  http.delete(Api.supporter.candidates.del + ID).then((r) => {
    notify(commit, r)
    return r
  }).catch((e) => notify(commit, e))
}

export function SET_LOGOUT({ commit }, exit) {
  http.delete(Api.login.auth)
  commit('SET_LOGOUT', exit);
}

export function GET_PENDENCIES({ state, commit }) {
  let endpoint = state.usuario.perfil == 'agregado_doutor' ? Api.supporter.pendencies_aggregate : Api.supporter.pendencies
  return http.get(endpoint).then(({ data }) => {
    commit('SET_PENDENCY', data);

    if (data.obrigatorias)
      state.usuario.pendencias = data.obrigatorias.filter(
        (p) => p.status == "pendente" || p.status == "reprovada"
      ).length;

    if (data.nao_obrigatorias)
      state.usuario.pendenciasOpcionais = data.nao_obrigatorias.filter(
        (p) => p.status == "pendente" || p.status == "reprovada"
      ).length;
    commit('SET_USER', state.usuario);
  });
}

/*
export function LOAD_PENDENCY({ commit, state }) {

  let url = ''
  let pay = {}
  
  if (state.usuario.perfil == 'agregado_doutor') {
    url = Api.supporter.pendency_aggregate
    pay = { id_agregado_doutor: state.usuario.id_doutor || state.usuario.id_agregado_doutor }
  } else {
    url = Api.supporter.pendency
    pay = { id_doutor: state.usuario.id_doutor }
  }

  return http.post(url, pay).then((pendency) => {

    //GAMBETA PROVISORIA
    for (let p of pendency.data) {
      switch (p.id_pendencia) {
        case 3: p.tipo = state.usuario.perfil == 'agregado_doutor' ? '16_id_agregado_doutor' : '1_id_doutor'; break;
        case 5: p.tipo = state.usuario.perfil == 'agregado_doutor' ? '18_ac_agregado_doutor_pf' : '3_ac_doutor_pf'; break;
        case 4: p.tipo = '7_comprovante_residencia'; break;
        case 7: p.tipo = state.usuario.perfil == 'agregado_doutor' ? '20_foto_agregado_doutor' : '5_foto_doutor'; break;
        case 9: p.tipo = state.usuario.perfil == 'agregado_doutor' ? '19_self_agregado_doutor_doc' : '4_self_doutor_doc'; break;
        case 6: p.tipo = state.usuario.perfil == 'agregado_doutor' ? '17_ac_agregado_doutor_pc' : '2_ac_doutor_pc'; break;
        case 12: p.tipo = '11_comprovante_pj'; break;
        case 14: p.tipo = '12_curriculo'; break;
        case 8: p.tipo = '8_comprovante_bancario'; break;
      }
    }
    commit('SET_PENDENCY', pendency.data);
  })
} */

export async function CONF() { return http.get(Api.conf) }

export function GET_SESSION({ commit }, data) {

  //WHITELABEL
  if (data && data.client) {

    return http.post(Api.login.whitelabel.replace("?", data.client), data)
      .then((res) => {

        // pegando o tipo de aplicação está rodando 
        // TODO - Melhoria, mesclar os serviços
        http.get(Api.conf).then((cfg) => {

          res.data.usuario.mode = cfg.data.app_mode
          res.data.usuario.ns_community = cfg.data.url_discourse
          res.data.usuario.link_antecipacao = cfg.data.link_antecipacao
          
          commit('SET_USER', res.data.usuario);
          router.push('/atendimento');
        })

        return res
      }).catch((e) => {
        e.status = 200
        notify(commit, e)
        return e
      })
      
    } else {
      // LOGIN NORMAL
      http.get(Api.login.session)
      .then((res) => {
        
        // pegando o tipo de aplicação está rodando 
        // TODO - Melhoria, mesclar os serviços
        http.get(Api.conf).then((cfg) => {

          res.data.dados.config = cfg.data
          res.data.dados.mode = cfg.data.app_mode
          res.data.dados.ns_community = cfg.data.url_discourse
          res.data.dados.link_antecipacao = cfg.data.link_antecipacao

          /* PENDENCIAS */
          if (res.data.dados.perfil === 'doutor' || res.data.dados.perfil === 'agregado_doutor') {

            let url = ''
            let pay = {}
            if (res.data.dados.perfil == 'agregado_doutor') {
              url = Api.supporter.pendency_aggregate
              pay = { id_agregado_doutor: res.data.dados.id_agregado_doutor }
            } else {
              url = Api.supporter.pendency
              pay = { id_doutor: res.data.dados.id_doutor }
            }

            http.post(url, pay).then((pendency) => {

              //GAMBETA PROVISORIA
              for (let p of pendency.data) {
                switch (p.id_pendencia) {
                  case 3: p.tipo = res.data.dados.perfil == 'agregado_doutor' ? '16_id_agregado_doutor' : '1_id_doutor'; break;
                  case 5: p.tipo = res.data.dados.perfil == 'agregado_doutor' ? '18_ac_agregado_doutor_pf' : '3_ac_doutor_pf'; break;
                  case 4: p.tipo = '7_comprovante_residencia'; break;
                  case 7: p.tipo = res.data.dados.perfil == 'agregado_doutor' ? '20_foto_agregado_doutor' : '5_foto_doutor'; break;
                  case 9: p.tipo = res.data.dados.perfil == 'agregado_doutor' ? '19_self_agregado_doutor_doc' : '4_self_doutor_doc'; break;
                  case 6: p.tipo = res.data.dados.perfil == 'agregado_doutor' ? '17_ac_agregado_doutor_pc' : '2_ac_doutor_pc'; break;
                  case 12: p.tipo = '11_comprovante_pj'; break;
                  case 14: p.tipo = '12_curriculo'; break;
                  case 8: p.tipo = '8_comprovante_bancario'; break;
                }
              }

              res.data.dados.pendency = pendency.data
              commit('SET_USER', res.data.dados);

              // agregado_doutor
              if (res.data.dados.perfil === 'agregado_doutor')
                router.push('/supporter/dashboard')

            })
          } else {
            if (res.data.dados.perfil == 'agregado_cliente'
              && !res.data.dados.white_label)
              res.data.dados.white_label = 'ns'

            commit('SET_USER', res.data.dados);
          }

          // agregado_doutor
          /* if (res.data.dados.onboard == null || res.data.dados.onboard == 'incompleto') */

          commit('SET_USER', res.data.dados);

          // agregado_doutor
          if (res.data.dados.perfil === 'agregado_doutor')
            router.push('/supporter/dashboard')
          if (res.data.dados.white_label)
            router.push('/atendimento');
          if (res.data.dados.perfil === 'cliente')
            router.push('/cliente/dashboard');
          if (res.data.dados.perfil === 'funcionario')
            router.push('/funcionario/acompanhamento')

          if (res.data.dados.perfil === 'doutor') {
            if (res.data.dados.primeiro_acesso && onboarding)
              router.push('/parceiro/onboarding');
            else
              router.push('/supporter/dashboard');
          }

        })

      })
      .catch(() => {
        commit('general/SET_STATUS', { text: 'Sistema indisponível no momento', color: 'red' }, { root: true });
      });
  }
}

export function LOAD_PERFIL({ commit }) {
  return http.get(Api.client.perfil)
    .then((res) => {
      if (res && res.data)
        commit('SET_PERFIL', res.data)
      return res
    }).catch((e) => {
      notify(commit, e)
      return e
    })
}

export function LOAD_PERFIL_SUPPORTER({ commit, state }) {
  let url = state.usuario.perfil == 'agregado_doutor' ? Api.supporter.perfil_aggregate : Api.supporter.perfil;
  return http.get(url).then((r) => {
    commit('SET_PERFIL', r.data)
    return r.data
  }).catch((e) => {
    notify(commit, e)
  })
}

export function LOAD_DOCS({ commit }) {
  return http.get(Api.supporter.docs).then((r) => {
    if (r.data)
      commit('SET_DOCS', r.data)
    return r
  }).catch((e) => {
    notify(commit, e)
    return e
  })
}

export function PUT_DOCS({ commit }, data) {
  return http.put(Api.supporter.docs, data)
    .then((r) => {
      if (r.data.dados) {
        r.data.dados.pj.cnpj = format.cnpj(r.data.dados.pj.cnpj)
        commit('SET_DOCS', r.data.dados)
      }
      notify(commit, r)
      return r
    }).catch((e) => {
      notify(commit, e)
      return e.response
    })
}

export function GET_BANK({ commit }) {
  return http.get(Api.supporter.dados_bancarios).then((r) => {
    if (r.data)
      commit('SET_BANK', r.data)
    return r
  }).catch((e) => {
    notify(commit, e)
    return e
  })
}
export function PUT_BANK({ commit }, data) {
  return http.put(Api.supporter.dados_bancarios, data).then((r) => {
    if (r.data.dados)
      commit('SET_BANK', r.data.dados)
    notify(commit, r)
    return r
  }).catch((e) => {
    notify(commit, e)
    return e.response
  })
}

export function TOKEN_SUPPORTER({ commit }, token) {
  return http.get(Api.supporter.token + token).then((r) => r.data).catch((e) => {
    notify(commit, e)
  })
}


export function SAVE_SUPPORTER({ commit, dispatch }, data) {
  data.celular = format.clear(data.celular)
  data.cep = format.clear(data.cep)

  for (var atr in data) if (data[atr] == '') delete data[atr]

  return http.post(Api.supporter.token + data.token, data).then((r) => {
    notify(commit, r)
    dispatch('SET_LOGIN', { login: data.email, senha: data.senha, origem: 'web2' })
  }).catch((e) => {
    notify(commit, e)
    return e
  })
}

// PENDENCIAS
export function ACCEPT_TERM({ commit }) {
  return http.post(Api.supporter.term).then(r => { notify(commit, r); return r })
    .catch((e) => {
      notify(commit, e)
    })
}

export function ACCEPT_TERM_SUPPORTER({ commit }) {
  return http.post(Api.supporter.term_supporter)
    .catch((e) => {
      notify(commit, e)
    })
}
export function ACCEPT_RULES({ commit, state }) {
  let api = state.usuario.perfil.agregado_doutor ? Api.supporter.rules_supporter : Api.supporter.rules;
  return http.post(api)
    .catch((e) => {
      notify(commit, e)
    })
}

export function ACCEPT_SLACK({ commit }) {
  return http.post(Api.supporter.slack.sync).then(r => { notify(commit, r); return r })
    .catch((e) => {
      notify(commit, e)
    })
}

export function SET_FILES({ commit, state }, data) {
  let api = state.usuario.perfil == 'agregado_doutor' ? Api.files_supporter : Api.files;
  return http.post(api, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((r) => {
      notify(commit, r)
      return r
    })
    .catch((e) => {
      notify(commit, e)
      return e
    })
}

export function LOAD_COMPETENCE({ commit, state }) {
  if (state.usuario.perfil !== 'agregado_doutor')
    return http.get(Api.supporter.competence).then((r) => {
      commit('SET_COMPETENCE', r.data)
      return r.data
    }).catch((e) => {
      notify(commit, e)
    })
}

export function SAVE_COMPETENCE({ state, commit }) {
  return http.post(Api.supporter.competence, state.competence.competencias_selecionadas).then((r) => {
    notify(commit, r)
  }).catch((e) => {
    notify(commit, e)
  })
}

export function SAVE_PERFIL({ commit }, newPerfil) {

  let perfil = Object.assign({}, newPerfil)
  perfil.celular = format.clear(perfil.celular)
  delete perfil.link_foto_doutor;

  return http.put(Api.supporter.perfil, perfil).then((r) => {
    if (r.data.dados)
      commit('SET_PERFIL', r.data.dados)
    notify(commit, r)
    return r
  }).catch((e) => {
    notify(commit, e)
  })
}

export function SET_VIDEO({ commit, state }, nome_video) {
  return http.put(Api.supporter.video, { nome_video: nome_video, status_video: true }).then(() => {
    state.usuario[`video_${nome_video}_visualizado`] = true
    commit('SET_USER', state.usuario);
  }).catch((e) => {
    notify(commit, e)
  })
}

export function REGISTER({ commit, state }, nome) {
  return http.put(Api.supporter.discourse + nome).then((r) => {
    state.usuario.usuario_discourse = nome
    commit('SET_USER', state.usuario)
    notify(commit, r)
  }).catch((e) => notify(commit, e))
}

export function LOAD_EXTRACT({ commit }, filter) {
  return http.post(Api.supporter.extract, filter).then((r) => {
    commit('SET_EXTRACT', r.data)
  }).catch((e) => {
    commit('SET_EXTRACT', [])
    notify(commit, e)
  })
}

export function NOTIFY_TELEGRAM({ commit, state }, allow) {
  if (!allow) {
    return http.post(Api.supporter.telegram, { canal: "telegram", autoriza: allow }).then(() => {
      state.usuario.autoriza_telegram = allow
      commit('SET_USER', state.usuario);
      /* if(allow) window.open(state.usuario.url_autorizacao_telegram+state.usuario.id_doutor, '_blank'); */
      /* r.data.msg = "Conta desativada com sucesso!";
      notify(commit, r); window.location = Api.motivo  */
    })
      .catch((e) => notify(commit, e))
  } else {
    state.usuario.autoriza_telegram = allow
    commit('SET_USER', state.usuario);
  }
}

export function DADOS_NF(_, { dt_previsao_pagamento, ciclo_semanal }) {
  // O ciclo é parte da identidade da nota, como a data: o semanal e o convencional
  // podem pagar no mesmo dia, cada um com a sua orientação (sc-9874).
  return http.get(Api.supporter.dados_nf + dt_previsao_pagamento + '?ciclo_semanal=' + ciclo_semanal)
}
export function POST_NF({ commit }, { arquivo, dt_previsao_pagamento, corrigir, ciclo_semanal }) {
  let type = corrigir ? 'put' : 'post'
  arquivo.append('ciclo_semanal', ciclo_semanal)
  return http[type](Api.supporter.nf + dt_previsao_pagamento, arquivo).then((r) => {
    notify(commit, r)
    return r
  }).catch((e) => {
    commit('general/SET_STATUS', { text: e.response.data.msg, color: 'red' }, { root: true })
    notify(commit, e)
    return e
  })
}

export function PUT_NF({ commit }, { arquivo, dt_previsao_pagamento, ciclo_semanal }) {
  arquivo.append('ciclo_semanal', ciclo_semanal)
  return http.put(Api.supporter.nf + dt_previsao_pagamento, arquivo).then((r) => {
    notify(commit, r)
    return r
  }).catch((e) => {
    notify(commit, e)
    return e
  })
}

export function CERTIFICATES_LIST({ commit }) {
  const certificatesTree = {
    title: "certificados",
    list: {},
    selected: [],
    text: ["Certificadoras", "Certificados", "seu certificado", "Seus certificados"],
    link: "https://nscommunity.netsupport.com.br/t/sugestoes-insercao-de-novas-certificacoes/6475",
    actions: {
      save: (listCertificate) => {
        let certificates = []
        listCertificate.map(certificate => {
          certificates.push({ id_certificado: certificate.id })
        })
        return http.post(Api.certificate.supporter, certificates).then((r) => {
          notify(commit, r)
          return r
        }).catch((e) => {
          notify(commit, e)
          return e
        })
      },
    }
  };
  commit('SET_CERTIFICATES', certificatesTree)

  http.get(Api.certificate.supporter).then((r) => {
    if (r.status == 200) {
      let certificates = []
      if (r.data.certificados_disponiveis) certificates = r.data.certificados_disponiveis
      if (r.data.certificados_selecionados) certificates = [...certificates, ...r.data.certificados_selecionados]
      let certificater = {}
      certificates.map(certificate => {
        if (!certificater[certificate.nome_certificadora]) certificater[certificate.nome_certificadora] = []

        certificater[certificate.nome_certificadora].push({
          id: certificate.id_certificado,
          id_parent: certificate.id_certificadora,
          nome: certificate.nome_certificado,
          descricao: certificate.descricao_certificado || certificate.descricao
        })
      })
      certificatesTree.list = certificater
      r.data.certificados_selecionados.map((certificate) => {
        certificatesTree.selected.push({
          id: certificate.id_certificado,
          id_parent: certificate.id_certificadora,
          nome: certificate.nome_certificado,
          descricao: certificate.descricao_certificado || certificate.descricao
        })
      })
      commit('SET_CERTIFICATES', certificatesTree)
    }
  }).catch((e) => {
    notify(commit, e)
    return e
  })
}

export function TOOLS_LIST({ commit }) {
  const toolsTree = {
    title: "ferramentas",
    list: {},
    selected: [],
    text: ["Tipo de ferramentas", "Ferramentas", "sua ferramenta", "Suas ferramentas"],
    link: "https://nscommunity.netsupport.com.br/t/sugestoes-insercao-de-novas-ferramentas/6474",
    actions: {
      save: (listTools) => {
        let tools = []
        listTools.map(tool => {
          tools.push({ id_ferramenta: tool.id })
        })
        return http.post(Api.tool.supporter, tools).then((r) => {
          notify(commit, r)
          return r
        }).catch((e) => {
          notify(commit, e)
          return e
        })
      },
    }
  };
  commit('SET_TOOLS', toolsTree)

  http.get(Api.tool.supporter).then((r) => {
    if (r.status == 200) {
      let tools = []

      if (r.data.ferramentas_disponiveis) tools = r.data.ferramentas_disponiveis
      if (r.data.ferramentas_selecionadas) tools = [...tools, ...r.data.ferramentas_selecionadas]
      let tooltype = {}
      tools.map(tool => {
        if (!tooltype[tool.nome_tipo_ferramenta]) tooltype[tool.nome_tipo_ferramenta] = []

        tooltype[tool.nome_tipo_ferramenta].push({
          id: tool.id_ferramenta,
          id_parent: tool.id_tipo_ferramenta,
          nome: tool.nome_ferramenta,
          descricao: tool.descricao_ferramenta || tool.descricao
        })
      })

      toolsTree.list = tooltype
      r.data.ferramentas_selecionadas.map((tool) => {
        toolsTree.selected.push({
          id: tool.id_ferramenta,
          id_parent: tool.id_tipo_ferramenta,
          nome: tool.nome_ferramenta,
          descricao: tool.descricao_ferramenta || tool.descricao
        })
      })
      commit('SET_TOOLS', toolsTree)

    }
  }).catch((e) => {
    notify(commit, e)
    return e
  })
}